import { Vpinput } from '@agrocloud/react-vapor-component/vpinput';
import React from 'react';

export const UserNameInputComponent = ({ field, form, ...restProps }: any) => (<Vpinput label="E-mail" {...field} autoComplete="email" {...restProps} />);

export const PasswordInputComponent = ({ field, form, ...restProps }: any) => (<Vpinput label="Password" type="password" {...field} autoComplete="current-password" {...restProps} />);